export const soilsTranslationsFr = {
  'soils.validation.min': 'Doit être supérieur à 0',
  'soils.validation.max': 'Doit être inférieur à 1',
  'soils.validation.rfu_ru': 'Ce champs est requis',
  'soils.edit.rfu.error': 'Valeur invalide',
  'soils.table.rfu_ru': 'RFU/RU',
  'arvalis.modal.title': "Paramétrez votre RU/RFU avec l'aide d'ARVALIS",
  'arvalis.modal.button.label': "Simulateur d'ARVALIS",
  'soil.arvalis-modal.button.label': "Comment paramétrer mon sol si je n'ai pas d'analyse complète ?",
  'arvalis.modal.text1':
    "Vous ne connaissez pas précisément votre RFU/RU ? Cliquez sur le simulateur développé par ARVALIS qui vous aidera à les définir en fonction de quelques critères. Cela vous permettra d'améliorer la fiabilité des recommandations d'irrigation de Pixagri tout au long de la campagne.",
  'arvalis.modal.text2':
    'Saisissez ensuite la valeur de RU et le rapport RFU/RU lors de la création de votre sol. Veillez également à sélectionner la texture la plus proche de votre sol.',
};
